const downloadBlob = (blob: Blob, filename: string) => {
    const href = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
};

const downloadBlobFromUrl = async (url: string, filename: string) =>
    fetch(url).then((response) => {
        if (response.status >= 400) {
            throw new Error('Failed fetching');
        }

        return response.blob().then((blob) => {
            downloadBlob(blob, filename);
        });
    });

export default downloadBlob;

export { downloadBlobFromUrl };
